// extracted by mini-css-extract-plugin
export default {"email":"HeaderMenu_email__KLBmR","logoutButton":"HeaderMenu_logoutButton__RiJfo","navLink":"HeaderMenu_navLink__D56mQ"};